import { Form, Modal, Radio, Typography, message, Divider } from "antd";
import { useState } from "react";
import Export from "redux/models/export";

const { Paragraph } = Typography;

export default function ExportCommissionApprovalsModal({
  open,
  onSuccess,
  onCancel,
  clientIds = [],
  recruiterIds = [],
}) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleExportCancel = () => {
    onCancel?.();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const params = { recruiterIds, clientIds };

      if (values.exportType === "all_records") {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        await Export.getReportCommissionApprovals({ ...params, timezone });
      } else {
        await Export.getReportCommissionApprovalsSummary(params);
      }

      message.success(
        "Commission Approvals export request successfully received! Check your email shortly",
      );

      onSuccess?.();
    } catch (err) {
      message.error("Failed to export commission approvals");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      open={open}
      centered
      className="s2-theme-style"
      title="Export"
      onOk={form.submit}
      onCancel={handleExportCancel}
      okButtonProps={{ loading }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          exportType: "number_of_records",
        }}
      >
        <Form.Item className="billing-radios" name="exportType">
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            options={[
              { label: "Number of Records", value: "number_of_records" },
              { label: "All Records", value: "all_records" },
            ]}
          />
        </Form.Item>
        <Divider />
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) => prev.exportType !== cur.exportType}
        >
          {({ getFieldValue }) => (
            <Paragraph>
              {getFieldValue("exportType") === "all_records"
                ? "Export all commission approval records for recruiters."
                : "Export the number of records for each recruiter."}
            </Paragraph>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
}
